import { render } from "./TagCreateModal.vue?vue&type=template&id=f70fa974&scoped=true&ts=true"
import script from "./TagCreateModal.vue?vue&type=script&lang=ts"
export * from "./TagCreateModal.vue?vue&type=script&lang=ts"

import "./TagCreateModal.vue?vue&type=style&index=0&id=f70fa974&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f70fa974"]])

export default __exports__